import React from 'react';
import { Grid } from '@smooth-ui/core-sc';
import { Article } from './Article';
export function NotFound() {
  return React.createElement(Grid, {
    gutter: 20
  }, React.createElement(Article, {
    style: {
      textAlign: 'center',
      overflow: 'hidden'
    }
  }, React.createElement("h1", null, "404"), React.createElement("p", {
    style: {
      textAlign: 'center',
      margin: '20px auto'
    }
  }, "We couldn\u2019t find what you were looking for."), React.createElement("a", {
    href: "https://dribbble.com/shots/2402048-Kylo-is-waiting"
  }, React.createElement("img", {
    alt: "Kylo is waiting",
    src: "https://cdn.dribbble.com/users/469578/screenshots/2402048/star_wars_kyloren_ren.gif",
    width: "400"
  })), React.createElement("p", {
    style: {
      textAlign: 'center',
      margin: '20px auto'
    }
  }, "Please contact the owner of the site that linked you to the original URL and let them know their link is broken.")));
}